import { render, staticRenderFns } from "./UpdateBooking.vue?vue&type=template&id=6db4c862&"
import script from "./UpdateBooking.vue?vue&type=script&lang=js&"
export * from "./UpdateBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports